module.exports = "https://dev.stanwinstonschool.com/meninblack.ea73580a7a57def3b991a3ae24455be6.jpg";